import { useEffect, useMemo } from 'react'
import type { ReadinessCtx } from '@/lib/readiness/useReadiness'
import { useMigrationStore, useMigrationScope } from '@/stores/migrationStore'
import { buildSummary } from '@/lib/migration/summary'
import { usePlanData } from '@/lib/migration/usePlan'

// Ensures the tracker's browser scope for the current org × index exists.
export function useEnsureMigrationScope(ctx: ReadinessCtx) {
  const { orgId, indexId } = ctx
  const ensureScope = useMigrationStore((s) => s.ensureScope)
  useEffect(() => {
    if (!orgId) return
    ensureScope(orgId, indexId)
  }, [orgId, indexId, ensureScope])
}

// The plan summary for the readiness pages (overview card, sidebar row, header
// CTA): the same MigrationSummary the hub reads, from the backend's plan; null
// for an index without a submission (I2 §11.3 as amended by I3 §13 e).
export function usePlanSummary(ctx: ReadinessCtx) {
  const { orgId, indexId, index } = ctx
  useEnsureMigrationScope(ctx)
  const mscope = useMigrationScope(orgId, indexId)
  const plan = usePlanData(orgId, indexId, !!index.submission)
  return useMemo(() => (index.submission ? buildSummary(index, plan, mscope) : null), [index, plan, mscope])
}
